import makeStyles from "@mui/styles/makeStyles";
import { PreviewBoxProps } from "./PreviewBox.types";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    position: "relative",
    marginBottom: 12,
    paddingBottom: 12,
    "&::after": {
      content: "''",
      position: "absolute",
      bottom: 0,
      right: -16,
      left: -16,
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
    },
    [theme.breakpoints.up("md")]: {
      flexDirection: "column",
      paddingBottom: 0,
      marginBottom: 0,
      "&::after": {
        content: "none",
      },
      "&:hover": {
        "& $check": {
          opacity: 1,
        },
        "& $name": {
          display: "none",
        },
        "& $actions": {
          display: "block",
        },
        "& $children": {
          border: `1px solid ${theme.palette.primary.main}`,
        },
      },
    },
  },
  rootSelected: {
    "&::before": {
      content: "''",
      position: "absolute",
      inset: "-12px -16px 0 -16px",
      background: theme.palette.grey[100],
      pointerEvents: "none",
    },
    "& $children": {
      [theme.breakpoints.up("md")]: {
        "&::after": {
          content: "''",
          position: "absolute",
          inset: -1,
          border: `2px solid ${theme.palette.common.black}`,
          pointerEvents: "none",
          borderRadius: 4,
        },
      },
    },
    "& $check": {
      opacity: 1,
    },
    "& $name": {
      fontWeight: "bold",
      [theme.breakpoints.up("md")]: {
        fontWeight: "normal",
      },
    },
    [theme.breakpoints.up("md")]: {
      "&::before": {
        content: "none",
      },
    },
  },
  check: {
    display: "flex",
    position: "absolute",
    width: 32,
    paddingRight: 12,
    [theme.breakpoints.up("md")]: {
      opacity: 0,
      justifyContent: "center",
      alignItems: "center",
      top: 8,
      left: 8,
      width: 32,
      height: 32,
      paddingRight: 0,
      zIndex: 1,
      overflow: "hidden",
      borderRadius: 4,
      background: theme.palette.common.white,
    },
  },
  children: {
    position: "relative",
    width: 64,
    height: 80,
    marginLeft: 32,
    border: `1px solid ${theme.palette.grey[500]}`,
    overflow: "hidden",
    borderRadius: 4,
    "& > div": {
      borderRadius: 4,
    },
    [theme.breakpoints.up("md")]: {
      marginLeft: 0,
      overflow: "initial",
      width: "100%",
      height: 200,
    },
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    paddingLeft: 8,
    paddingRight: 8,
    [theme.breakpoints.up("md")]: {
      minHeight: 40,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  name: {
    display: "box",
    overflow: "hidden",
    position: "relative",
    textOverflow: "ellipsis",
    lineClamp: 2,
    boxOrient: "vertical",
    fontSize: 16,
    lineHeight: "20px",
    fontWeight: "normal",
    [theme.breakpoints.up("md")]: {
      marginTop: 8,
      fontSize: 12,
      lineHeight: "16px",
    },
  },
  actions: {
    display: "none",
    marginTop: 4,
    "& button": {
      height: 16,
    },
    "& button:first-child": {
      marginRight: 12,
    },
    [theme.breakpoints.up("md")]: {
      marginTop: 8,
    },
  },
  buttons: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  more: {
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  favorite: {
    alignSelf: "flex-end",
    [theme.breakpoints.up("md")]: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "absolute",
      top: 8,
      right: 8,
      width: 32,
      height: 32,
      zIndex: 1,
      overflow: "hidden",
      borderRadius: 4,
      background: theme.palette.common.white,
    },
  },
  favoriteButton: (props: PreviewBoxProps) => ({
    "& svg": {
      width: 24,
      height: 24,
      "& path": {
        fill: props.favorited
          ? theme.palette.yellow.dark
          : theme.palette.common.white,
        stroke: props.favorited
          ? theme.palette.yellow.dark
          : theme.palette.grey[700],
      },
    },
  }),
}));
